<!--  -->
<template>
  <div>
    <div class="course-box" v-for="(item, index) in courseList" :key="index">
      <div>
        <h2>
          <i v-if="item.productName.substr(0, 1) == '【'" class="title-special-processing"></i
          >{{ item.productName }}
        </h2>
        <p>¥{{ item.productPrice }}</p>
      </div>
      <p class="sku-name">{{ item._skuname }}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    courseList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.course-box {
      padding: 10px 0;
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        h2 {
          width: 450px;
          overflow: hidden;
          color: #333;
          font-weight: 400;
          font-size: 33px;
          line-height: 38px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        p {
          padding-top: 5px;
          color: #333;
          font-size: 25px;
        }
      }
      .sku-name {
        padding-top: 5px;
        color: #787878;
        font-size: 28px;
      }
    }
</style>
